import { render } from "./userNotification.vue?vue&type=template&id=c7f3f988"
import script from "./userNotification.vue?vue&type=script&lang=js"
export * from "./userNotification.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/base/header/user/userNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c7f3f988"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c7f3f988', __exports__)) {
    console.log('reload')
    api.reload('c7f3f988', __exports__)
  }
  
  module.hot.accept("./userNotification.vue?vue&type=template&id=c7f3f988", () => {
    console.log('re-render')
    api.rerender('c7f3f988', render)
  })

}


export default __exports__